import styled from "@emotion/styled";
import { Footer } from "@energyx-dev/energyx-ui";
import EnMainFooter from "components/common/EnFooter";
import { TermsHeader } from "components/terms/TermsHeader";
import useTranslation from "hooks/useTranslation";
import { LastStage } from "pages/lastStage/LastStage";
import { Logout } from "pages/logout/Logout";
import { Verification } from "pages/verification/Verification";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { routes } from "routes/router";

export const Layout = () => {
  const location = useLocation();
  const isEnglishPage = useTranslation();

  return (
    <>
      <Wrap>
        {location.pathname === "/terms" && <TermsHeader />}
        <LayoutContainer>
          <Routes>
            <Route path="*" element={<Navigate to="/login" replace />} />
            <Route path="logout" element={<Logout />} />
            <Route path="verification" element={<Verification />} />
            <Route path="verification/completed" element={<LastStage />} />
            <Route path="verification/expired" element={<LastStage />} />

            {routes.map((route) => (
              <Route key={route.name} path={route.path} element={<route.component />} />
            ))}
          </Routes>
        </LayoutContainer>
        {location.pathname !== "/logout" && !isEnglishPage && (
          <Footer deployEnv={process.env.DEPLOY?.replace("prod", "main")} />
        )}
        {location.pathname !== "/logout" && isEnglishPage && (
          <EnMainFooter deployEnv={process.env.DEPLOY?.replace("prod", "main") as any} />
        )}
      </Wrap>
    </>
  );
};
const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  font-family: "Pretendard", sans-serif !important;
`;

const LayoutContainer = styled.section`
  display: flex;
  flex: 1;
  /* justify-content: center; */
  align-items: center;
  flex-direction: column;
  margin: 0px auto;
  max-width: 1248px;

  ${({ theme }) => theme.breakpoints.down("TABLET")} {
    width: 100%;
  }
`;
